import { GET_USER, GET_USER_ERROR, GET_USER_SUCCESS } from "core-web/state/models/User/constants";

import Cookies from "js-cookie";
import GetUser from "core-web/libs/GrebbCommerceAPI/User/GetUser";
import getFavorites from "./getFavorites";
import getMemberPromotions from "./getMemberPromotions";
import { hashString } from "core-web/utils/hashString";
import setUser from "./setUser";
import store from "core-web/state/store";

export const getUser = () => async (dispatch, getState) => {
    dispatch({ type: GET_USER, initFetchingFavorites: true });

    try {
        const applicationId = getState().application?.applicationId;
        const res = await GetUser(applicationId);

        if (await res.ok()) {
            const responseBody = await res.body();

            Cookies.set("user_logged_in", true, { expires: 7 });
            if (responseBody.data.id) {
                Cookies.set("user_id", responseBody.data.id, { expires: 7 });
            }
            if (responseBody.data.email) {
                const hashedUserEmailSHA1 = await hashString(responseBody.data.email, "SHA-1");
                Cookies.set("hashed_user_email", hashedUserEmailSHA1, { expires: 7 });
            }

            setUser(responseBody.data);
            getFavorites();
            getMemberPromotions(responseBody.data.email);

            dispatch({ type: GET_USER_SUCCESS });

            return responseBody.data;
        }

        const status = await res.status();

        if (status === 401) {
            Cookies.remove("user_logged_in");
            Cookies.remove("user_id");
            Cookies.remove("hashed_user_email");
        }

        // todo: handle response status codes
        throw await res.status();
    } catch (error) {
        console.error(error);
        dispatch({ type: GET_USER_ERROR });

        return;
    }
};

export default () => store.dispatch(getUser());
